"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseComponents = exports.createPageConfig = exports.createAppConfig = exports.createProjectConfig = void 0;
var createProjectConfig_1 = require("./createProjectConfig");
Object.defineProperty(exports, "createProjectConfig", { enumerable: true, get: function () { return createProjectConfig_1.createProjectConfig; } });
var createAppConfig_1 = require("./createAppConfig");
Object.defineProperty(exports, "createAppConfig", { enumerable: true, get: function () { return createAppConfig_1.createAppConfig; } });
var createPageConfig_1 = require("./createPageConfig");
Object.defineProperty(exports, "createPageConfig", { enumerable: true, get: function () { return createPageConfig_1.createPageConfig; } });
__exportStar(require("./BaseApis"), exports);
var BaseComponents_1 = require("./BaseComponents");
Object.defineProperty(exports, "BaseComponents", { enumerable: true, get: function () { return __importDefault(BaseComponents_1).default; } });
__exportStar(require("./BaseComponents"), exports);
__exportStar(require("./lifecycle"), exports);
//# sourceMappingURL=index.js.map